import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface popupState {
  showLoginModal: boolean;
  showSignupModal: boolean;
}

const initialState: popupState = {
  showLoginModal: false,
  showSignupModal: false,
};

export const popupModalSlice = createSlice({
  name: "popupModal",
  initialState,
  reducers: {
    setLoginModalState: (state, action: PayloadAction<boolean>) => {
      if (action.payload === true) {
        state.showSignupModal = false;
      }
      state.showLoginModal = action.payload;
    },
    setSignupModalState: (state, action) => {
      if (action.payload === true) {
        state.showLoginModal = false;
      }
      state.showSignupModal = action.payload;
    },
  },
});

export const { setLoginModalState, setSignupModalState } =
  popupModalSlice.actions;
export default popupModalSlice.reducer;
